/**
 * TS020: rewrite collection-scoped product links to /products/handle.
 * Catches merchant HTML, Klevu tiles, and leftover theme hrefs.
 * Leaves /collections/handle links alone.
 */
(function () {
  var PRODUCT_IN_COLLECTION = /\/collections\/[^/]+\/products\/([^/?#]+)/;
  var INTERNAL_HOSTS = {
    'www.tatsoul.com': true,
    'tatsoul.com': true,
    'sb-tatsoul.myshopify.com': true,
    'tatsoul.myshopify.com': true
  };

  function isInternal(url) {
    return url.origin === window.location.origin || INTERNAL_HOSTS[url.hostname] === true;
  }

  function canonicalPath(url) {
    var match = url.pathname.match(PRODUCT_IN_COLLECTION);
    if (!match) return '';
    return '/products/' + match[1] + url.search + url.hash;
  }

  function cleanHref(href) {
    if (!href || href.indexOf('/collections/') === -1 || href.indexOf('/products/') === -1) {
      return href;
    }
    try {
      var url = new URL(href, window.location.origin);
      if (!isInternal(url)) return href;
      var next = canonicalPath(url);
      return next || href;
    } catch (err) {
      return href;
    }
  }

  function cleanNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.hasAttribute && node.hasAttribute('href')) {
      var href = node.getAttribute('href') || '';
      var next = cleanHref(href);
      if (next && next !== href) node.setAttribute('href', next);
    }
    if (node.hasAttribute && node.hasAttribute('data-product-url')) {
      var dataUrl = node.getAttribute('data-product-url') || '';
      var dataNext = cleanHref(dataUrl);
      if (dataNext && dataNext !== dataUrl) node.setAttribute('data-product-url', dataNext);
    }
  }

  function cleanRoot(root) {
    if (!root || !root.querySelectorAll) return;
    cleanNode(root);
    var links = root.querySelectorAll('a[href*="/collections/"][href*="/products/"], [data-product-url*="/collections/"][data-product-url*="/products/"]');
    for (var i = 0; i < links.length; i++) cleanNode(links[i]);
  }

  cleanRoot(document.documentElement);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      cleanRoot(document);
    });
  }

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          cleanRoot(nodes[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
